export default __webpack_public_path__ + "static/media/tabs.82e767b0.svg";